// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import TeamOutlinedSvg from "@fishx/icons-svg/es/asn/TeamOutlined";
import FishxIcon from '../components/FishxIcon';

var TeamOutlined = function TeamOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: TeamOutlinedSvg
  }));
};

TeamOutlined.displayName = 'TeamOutlined';
export default React.forwardRef(TeamOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/TeamOutlined.js
// module id = 4256
// module chunks = 0